import * as yup from 'yup';

const DatasourceSchema = yup.object().shape({

}).required();

export default DatasourceSchema